import { Divider, Flex, Text, VStack } from "@chakra-ui/react";
import TicketsCart from "../../components/TicketsCart/TicketsCart";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const MyCart = () => {
    const { t } = useTranslation("default");
    const location = useLocation();
    const [event, setEvent] = useState(location.state?.event || JSON.parse(localStorage.getItem("event")));
    const [cart, setCart] = useState(location.state?.cart || JSON.parse(localStorage.getItem("cart")));

    return <Flex w={"100%"} alignItems={"center"} justifyContent="center" className="ticket-section" bgColor={'#FFFFFF'}>
        <Flex flexDirection={{ base: 'column', md: 'row' }} gap={'32px'} w={{ base: '100%', sm: '7xl' }} p={{ base: '16px', md: 0 }}
            alignItems={"flex-start"} py={'48px'} justifyContent={"space-between"}>
            <VStack align="center" spacing={4} flex="1" gap="32px" w={"100%"}>
                <Divider borderColor={'#BFBFBF'} w={{ base: '90%', md: '100%' }} alignSelf={"center"} />
                <Flex flexDirection={'column'} gap={'32px'} w={"100%"}>
                    <Text fontSize={{ base: "20px", md: "28px" }} textAlign={"center"}>
                        {t('event.tickets')}
                    </Text>
                    <TicketsCart tickets={event.ticketTypes} cart={cart} onBuy={(cart) => console.log(cart)} finalCart={true} />
                </Flex>
            </VStack>
        </Flex>
    </Flex>;
}

export default MyCart;
